var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 13.125H4V4.375H10.875V13.125ZM10.875 3.125H4C3.66848 3.125 3.35054 3.2567 3.11612 3.49112C2.8817 3.72554 2.75 4.04348 2.75 4.375V13.125C2.75 13.4565 2.8817 13.7745 3.11612 14.0089C3.35054 14.2433 3.66848 14.375 4 14.375H10.875C11.2065 14.375 11.5245 14.2433 11.7589 14.0089C11.9933 13.7745 12.125 13.4565 12.125 13.125V4.375C12.125 4.04348 11.9933 3.72554 11.7589 3.49112C11.5245 3.2567 11.2065 3.125 10.875 3.125ZM9 0.625H1.5C1.16848 0.625 0.850537 0.756696 0.616116 0.991116C0.381696 1.22554 0.25 1.54348 0.25 1.875V10.625H1.5V1.875H9V0.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copyLink.6ca9afc6.svg";
export { ForwardRef as ReactComponent };